export default [
    {
        path: '/events',
        name: 'PageEventsList',
        meta: { title: 'events.listTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/events'),
    },
    {
        path: '/events/create',
        name: 'PageEventsCreate',
        meta: { title: 'events.createFormTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/events/create'),
    },
    {
        path: '/events/:id/edit',
        name: 'PageEventsEdit',
        meta: { title: 'events.editFormTitle', roles: ['ADMIN'] },
        component: () => import('@/pages/events/id/edit'),
    },
]
